"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _ErrorIcon = _interopRequireDefault(require("../../ErrorIcon")),
    _styles = require("../styles");

function getDecorator(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      c = b.isSuffix,
      d = b.isErrorIcon,
      e = b.iconId,
      f = b.errorMessage;
  if (!a) return null;
  var g = c ? _styles.SUFFIX : _styles.PREFIX,
      h = "string" == typeof a ? _react["default"].createElement(_Icon["default"], {
    color: "michael",
    className: g,
    name: a,
    size: 20
  }) : _react["default"].cloneElement(a, {
    className: (0, _classnames["default"])(a.props.className, g)
  });
  return d ? _react["default"].createElement(_ErrorIcon["default"], {
    id: e,
    className: g,
    errorMessage: f
  }) : h;
}

function InputContainer(a) {
  var b = a.children,
      c = a.className,
      d = a.prefix,
      e = a.suffixIcon,
      f = a.valid,
      g = a.errorMessage,
      h = a.id,
      i = a.focusInput;
  return _react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])(_styles.INPUT_CONTAINER, c),
    onClick: i,
    onKeyPress: void 0
  }, getDecorator(d), b, getDecorator(e, {
    isSuffix: !0,
    isErrorIcon: !f,
    iconId: h,
    errorMessage: g
  }));
}

var _default = (0, _react.memo)(InputContainer);

exports["default"] = _default;